// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  version: require('../../package.json').version,
  production: false,
  AIRTABLE_API_KEY: 'patiJbFSX712cqYQA.faf0d8dc07cbee8806083a95bac89d5a3370d9e936ebca72c2a53236c7b40297',
  AMIRA_SRS_API_KEY: 'placeholderKey',
  AMIRA_SIS_API_KEY: 'placeholderKey',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
